<template>
    <el-dialog  title="编辑站点信息" :close-on-click-modal="false" :visible.sync="showBlock" :destroy-on-close="true"  width="870px" :before-close="handleClose">
        <el-form :model="formDate" ref="formDate" status-icon :rules="rules" label-width="86px" class="demo-ruleForm">
            <div class="common-items-center">
                <el-form-item  label="LOGO"  prop="icon" @getUpload="getUpload">
                    <div style="width:240px">
                        <UpLoadImng width="76" height="76" :showMark="false" size="1" keyVal="icon" ref="icon" limit="1" rules="jpg,gif,png" @getUpload="getUpload" />
                    </div>
                </el-form-item>
                <el-form-item  label="背景图" prop="background" @getUpload="getUpload">
                    <UpLoadImng width="76" height="76" :showMark="false" size="1" keyVal="background" ref="background" limit="1" rules="jpg,gif,png" @getUpload="getUpload" />
                </el-form-item>
            </div>
            <div class="common-items-center">
                <el-form-item  label="系统名称" prop="factoryName"   :rules="[{required:true,message:'系统名称不能为空'}]">
                    <el-input v-model="formDate.factoryName" maxlength="20"  :size="this.$store.state.popSize" style="width:240px" placeholder="请输入系统名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="部署方式" prop="deploymentMode">
                    <SelectBlock keyVal="deploymentMode" ref="deploymentMode" :size="this.$store.state.popSize"  title="" placeholder="请选择菜单状态"  left="0" right="0" :options="deploymentModeList" width="240" @getVal="getValueB" />
                </el-form-item>
            </div>
            <div class="common-items-center">
                <el-form-item  label="企业名称" prop="companyName" :rules="[{required:true,message:'企业名称不能为空'}]">
                    <el-input v-model="formDate.companyName" maxlength="15"  style="width:240px" :size="this.$store.state.popSize" placeholder="请输入企业名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="设备类型">
                    <checkTree keyVal="shebeiValue" ref="shebeiValue" :size="this.$store.state.popSize" :options="typeLists" width="240" placeholder="请选择菜单状态" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' childKey="children" @getVal="getValSEB"/>
                </el-form-item>
            </div>
            <div class="common-items-center">
                <el-form-item  label="用户名称" prop="userName" :rules="[{required:true,message:'用户名称不能为空'}]">
                    <el-input v-model="formDate.userName" maxlength="4" :disabled="true" :size="this.$store.state.popSize" style="width:240px" placeholder="请输入联系人" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="手机号码" prop="phone" >
                    <div class="common-relatives">
                      <el-input v-model="formDate.phone" maxlength="11" :size="this.$store.state.popSize" style="width:240px"  placeholder="请输入手机号码" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                    </div>
                    <CopyBtn :text="formDate.phone" :postion="true" :right="15" :bottom="2"></CopyBtn>
                </el-form-item>
            </div>
            <div class="common-items-center">
                <el-form-item  label="用户账号" prop="account">
                    <div class="common-relatives">
                       <el-input v-model="formDate.account" maxlength="20" :disabled="true" :size="this.$store.state.popSize" style="width:240px" placeholder="请输入账号" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                       <CopyBtn :text="formDate.account" :postion="true" :right="15" :bottom="2"></CopyBtn>
                    </div> 
                </el-form-item>
                <el-form-item  label="绑定域名" prop="domainName">
                    <el-input v-model="formDate.domainName" maxlength="50" :size="this.$store.state.popSize" style="width:240px" placeholder="请输入域名" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                </el-form-item>
            </div>
            <el-form-item  label="选择区域" prop="codeAddress" :rules="[{required:true,message:'区域不可为空'}]" >
                <ProvCty ref="codeAddress" width="240" @getVal="getVal"></ProvCty>
            </el-form-item>
            <el-form-item  label="详细地址" prop="remarks">
                <el-input v-model="formDate.address" type="textarea" :size="this.$store.state.popSize" maxlength="150" style="width:560px" placeholder="请输入详细地址" :autosize="{minRows:1}" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'  autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item  label="工厂类型" prop="factoryType" :rules="[{required:true,message:'工厂类型不能为空'}]">
                <SelectBlock keyVal="factoryType" ref="factoryType"  :size="this.$store.state.popSize" title="" placeholder="请选择工厂类型"  left="0" right="0" :options="optionList" width="380" @getVal="getValue" />
                <div  class="block-line">
                   <el-tree  :data="dataList"  ref="tree" node-key="id"   :props="defaultProps"></el-tree>
                </div>
            </el-form-item>
            <el-form-item  label="备注信息" prop="explains">
                <el-input v-model="formDate.explains" type="textarea" ize="medium" maxlength="100" placeholder="请输入描述内容" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' :autosize="{minRows:3}"  autocomplete="off"></el-input>
            </el-form-item>
            <div class="warp-btn">
                <el-form-item>
                    <div  class="dialog-footer">
                        <el-button @click="handleClose">取消</el-button>
                        <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                    </div>
                </el-form-item>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
  import {url,userApi,api} from '@/utils/config'
  import {putFun,getFun,postFun} from '@/utils/httpFun'
  import {isEmpty,checkPhone,checkAccout,checkHttp} from '@/utils/util'
  import UpLoadImng from '@/components/component-block/block-uploadImg.vue'
  import checkTree from '@/components/component-block/block-checkTree.vue'
  export default{
    components:{
        UpLoadImng:UpLoadImng,
        checkTree:checkTree
    },
     data(){
       return{
            rules:{
               phone:[{required:true,validator:checkPhone, trigger:'blur'}],
               domainName:[{required:false,validator:checkHttp, trigger:'blur'}]
            },
            defaultProps: {
                children: 'childMBs',
                label: 'name'
            },
            deploymentModeList:[
               { indexNo: '1', selectName: 'SASS'}, 
               { indexNo: '2', selectName: '私有化'}
            ],
            showBlock: false,
            dataList:[],
            typeLists:[],
            optionList:[],
            addressName:"",
            shebeiValue:"",
            formDate: {
                icon:"",             //站点LOGO
                background:"",       //企业背景图
                factoryName:"",      //系统名称
                companyName:"",      //企业名称
                codeAddress:"",      //区域code 
                address:"",          //详细地址
                userName:"",         //联系人姓名
                phone:"",            //用户电话
                account:"",          //用户账号 
                domainName:"",          //绑定域名
                explains:"",         //备注信息
                factoryType:"",      //工厂类型
                deploymentMode:"",   //部署方式 1SASS 2私有
            },
       }
     }, 
     created(){
        
        // setTimeout(res=>{
        //     let parms = {
        //         defaultVal:[{url:'http://192.168.1.29:9000/brj-test/20221228164043-331?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=DHTSO1KC6ALTS56Q0XJD%2F20221228%2Fdsfdsfs%2Fs3%2Faws4_request&X-Amz-Date=20221228T085956Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=e761924cdae07f59caf6a54ff609d7010f5e532b13f0b1de3daf6300170c8d4d'}],
        //         defaultImg:['20221228164043-331']
        //     }
        //     this.$refs.icon.setVal(parms)       
        // },1000)

     },
     methods:{
        
        //获取省市菜单下拉的值
        getVal(ev){
           this.formDate.codeAddress =  (ev.DCodeVal).join()
           this.addressName =ev.AProve.name+ev.BCity.name+ev.COunty.name
        },
        //获取工厂类型的值
        getValue(ev){
           this.formDate.factoryType = ev.indexNo
           this.getTypeMenu(ev.indexNo)
        },

        //选择部署方式
        getValueB(ev){
          this.formDate.deploymentMode = ev.indexNo
        },

        //重置输入框信息
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //提交
        submitForm(formName) {
            if(!!!this.formDate.icon){
                this.$message.warning('请上传icon');
                return;
            }
            if(!!!this.formDate.background){
                this.$message.warning('请上传背景图');
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                        this.addMess()
                    }else{
                        return false;
                }
            });
        },

        //更新
        async addMess(){
           var parm = {
                id:this.formDate.id,                                //系统的ID          
                factoryName:this.formDate.factoryName,              //系统名称
                companyName:this.formDate.companyName,              //企业名称
                codeAddress:this.formDate.codeAddress,              //区域code 
                address:this.addressName+"/"+this.formDate.address, //详细地址
                userName:this.formDate.userName,                    //联系人姓名
                phone:this.formDate.phone,                          //用户电话
                account:this.formDate.account,                      //用户账号 
                domainName:this.formDate.domainName,                      //绑定域名
                explains:this.formDate.explains,                    //备注信息
                factoryType:this.formDate.factoryType,              //工厂类型
                deploymentMode:this.formDate.deploymentMode,        //部署方式
                deviceTypeIds:this.shebeiValue,                     //设备
                icon:this.formDate.icon,                            //站点LOGO
                background:this.formDate.background,                //站点背景图
           }
           parm.operator = this.$store.state.operator
           await putFun(userApi.FACTORYUPDATE,parm,res=>{
                if(res.data){
                    this.$message.success('编辑成功');
                }else{
                    this.$message.warning('编辑失败')
                }
                this.showBlock = false
                this.$parent.getList() 
           }) 
        },
        
        //获取设备生产类型
        getValSEB(ev){
            this.shebeiValue = ev.val
        },

        //开启弹窗
        showMessage(ev){
           console.log("哈哈",ev) 
           this.optionList = ev.list
           let text = ev.val.address
           this.addressName = text.substring(0,text.indexOf("/"))
           let address = text.substring(text.indexOf("/")+1)
           this.formDate = {
                id:ev.val.id,
                factoryName:ev.val.factoryName,      //系统名称
                companyName:ev.val.companyName,      //企业名称
                codeAddress:ev.val.codeAddress,      //区域code 
                address:address,                     //地址
                userName:ev.val.userName,            //联系人姓名
                phone:ev.val.phone,                  //用户电话
                account:ev.val.account,              //用户账号 
                domainName:ev.val.domainName,              //绑定域名
                explains:ev.val.explains,            //备注信息
                factoryType:ev.val.factoryType,      //工厂类型
                deploymentMode:ev.val.deploymentMode //部署方式
           }
           
           this.showBlock = true 
           this.getTypeMenu(ev.val.factoryType)
           this.getDEVtYPE()
           this.getSHEN(ev.val.id)
           this.$nextTick(res=>{
                this.$refs.factoryType.setVal(ev.val.factoryTypeName)
                this.$refs.codeAddress.setVal(ev.val.codeAddress.split(","))
                this.$refs.deploymentMode.setVal(ev.val.deploymentMode*1==1 ? "SASS":"私有化")
                this.lookImg(ev.val)
           })
           
        },

        //图片改动后值得变化
        getUpload(ev){
            if(ev.val.length == 0)
                this.formDate[ev.key] = null
            else
                this.formDate[ev.key] = ev.val[0] 
        },
        //查看Logo及其背景图
        lookImg(ev){
            this.formDate.icon = ev.icon                            //公司ICON
            this.formDate.background = ev.background                //公司背景
            let iconParms = {
                bucketName:api.bucketName,
                objectName:ev.icon
            }
            let backgroundParms = {
                bucketName:api.bucketName,
                objectName:ev.background
            }
        
            getFun(url.SHOWIMG,iconParms,res=>{
                let parms = {
                defaultVal:[{url:res.data}],
                defaultImg:[ev.icon]
                }
                this.$refs.icon.setVal(parms)
            })
            getFun(url.SHOWIMG,backgroundParms,res=>{
                let parms = {
                    defaultVal:[{url:res.data}],
                    defaultImg:[ev.background]
                }
                this.$refs.background.setVal(parms)
            })  
        },

        //工厂类型时候的菜单
        async getTypeMenu(ftId){
          let parms = {
             ftId:ftId   
          }  
          await getFun(userApi.FACTROYTYPEMENU,parms,res=>{
              this.dataList = res.data
          })
        },

        //生产设备类型
        async getDEVtYPE(){
           await getFun(userApi.FACTROYDEVETYP,{},res=>{
                this.typeLists = res.data
           }) 
        },

        //获取选中的生产设备类型
        async getSHEN(id){
            let parms = {
                factoryId:id   
            }  
            await getFun(userApi.FACTORYGETTYPE,parms,res=>{
                this.shebeiValue = !res.data.deviceTypeIds ? []:res.data.deviceTypeIds
                this.$nextTick(res=>{
                     this.$refs.shebeiValue.setVal(this.shebeiValue)
                })
            })
        },
       
        //关闭弹窗
        handleClose() {
            this.showBlock = false
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   #container{
        padding:0px;
        margin: 0px;
        width: 100%;
        height: 800px;
    }
    .block-line{
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        min-height:84px;
        max-height:300px;
        overflow-y: auto;
        padding:15px;
        box-sizing: border-box;
        margin-top:16px;
    } 
</style>